

































import { getDefaultThumbnailForMediaType } from '@/web/utils/media';
import RightBlockSourceType from '@/core/typings/enums/RightBlockSourceType';

export default {
  name: 'PlaylistStudentThumbnail',
  data() {
    return {
      hover: false,
    };
  },
  props: {
    playlist: {
      type: Object,
    },
    showListIcon: {
      type: Boolean,
      default: false,
    },
    showPlayIcon: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
    },
  },
  computed: {
    backgroundImage(): object | null {
      const media = this.playlist?.cover_file || this.playlist?.media;
      const thumbnailUrl =
        media?.thumbnail ||
        getDefaultThumbnailForMediaType(
          this.playlist?.media?.file_content || this.source
        );

      if (!thumbnailUrl) return null;

      const res = {
        backgroundImage: 'url(' + thumbnailUrl + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      };

      if (media && media.focal_point_x && media.focal_point_y) {
        const { focal_point_x, focal_point_y } = media;
        res.backgroundPosition = `${focal_point_x}% ${focal_point_y}%`;
      }

      return res;
    },
  },
};
